import { Table as AntdTable, Tabs as AntdTabs, Flex } from 'antd';
import styled from 'styled-components';

import { CSS_PREFIX } from '@/constants/styles';
import { BlueColors, GreenColors, NeutralColors } from '@/theme';

import {
  ROW_CONFIRMED_CLASS,
  ROW_EDITING_CLASS,
  ROW_HIGHLIGHTED_CLASS
} from './constants';

export const Root = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const OuterScroll = styled(Flex)<{ $virtual?: boolean }>`
  width: 100%;
  overflow-x: hidden;
  overflow-y: ${props => (props.$virtual ? 'hidden' : 'auto')};
  -webkit-overflow-scrolling: touch;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
`;

export const TableContainer = styled.div`
  flex: 1;
  position: relative;
`;

export const Table = styled(AntdTable)`
  width: 100%;
  --rc-virtual-list-scrollbar-bg: ${NeutralColors[50]};

  /* AntD virtual table re-prefixes rc-virtual-list, so the scrollbar class
     becomes \`\${tablePrefix}-tbody-virtual-scrollbar-*\`. Match by suffix so
     this works across AntD versions and without depending on CSS_PREFIX. */
  [class$='-scrollbar-vertical'] {
    visibility: visible !important;
    width: 12px !important;
  }

  [class$='-scrollbar-horizontal'] {
    visibility: visible !important;
    height: 12px !important;
  }

  .${ROW_HIGHLIGHTED_CLASS} {
    .${CSS_PREFIX}-table-cell {
      background-color: ${BlueColors[10]} !important;
    }
  }

  .${ROW_EDITING_CLASS} {
    .${CSS_PREFIX}-table-cell {
      background-color: ${BlueColors[10]} !important;
    }
  }

  .${ROW_CONFIRMED_CLASS} {
    .${CSS_PREFIX}-table-cell {
      background-color: ${GreenColors[10]} !important;
    }
  }
` as typeof AntdTable;

export const TableContent = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  top: 0;
  right: 0;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  height: 75px;
  background-color: ${NeutralColors[0]};
  border-top: 1px solid ${NeutralColors[20]};
`;

export const Header = styled.div`
  padding: 0 16px;
  margin-bottom: 12px;
  display: flex;
  flex-wrap: wrap;
  background: white;
  gap: 8px;
  overflow-x: auto;
`;

export const HeaderActions = styled(Flex)<{ $compactControls: boolean }>`
  ${({ $compactControls }) =>
    $compactControls &&
    `
      [data-testid='column-visibility-button'],
      [data-testid='sort-button'] {
        display: inline-flex;
        width: 32px;
        min-width: 32px;
        height: 32px;
        padding: 4px;
        align-items: center;
        justify-content: center;
        line-height: 1;

        svg {
          display: block;
          flex: 0 0 auto;
        }
      }
    `}
`;

export const LeftMenuContainer = styled(Flex)`
  position: relative;
  display: flex;
  flex: 1;
`;

export const LeftMenuContent = styled(Flex)`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-x: auto;
`;

export const SearchContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;

  .${CSS_PREFIX}-input-affix-wrapper {
    width: 550px;
    max-width: 100%;
    background-color: ${NeutralColors[10]};
  }
`;

export const FilterTagsRow = styled.div`
  padding: 0 16px;
  margin-bottom: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  overflow-x: auto;
`;

export const TabsWrapper = styled(AntdTabs)`
  padding: 0 12px;

  .panorama-tabs-nav {
    margin-bottom: 0;
  }
`;
